import React, {useEffect, useState} from 'react';
import {t} from "i18next";
import {Modal} from "../components/Modal";
import {deleteMedicalCondition, updateMedicalCondition} from "../service/accountApi";
import Cookies from "universal-cookie";

export const EditMedicalConditionForm = (props) => {
    const {
        showEditMedicalConditionForm,
        setShowEditMedicalConditionForm,
        medicalConditionData,
        setMedicalConditionData,
        accountDetails,
        setAccountDetails
    } = props;

    const cookies = new Cookies();
    const locale = cookies.get("locale");

    const [medicalConditionDetails, setMedicalConditionDetails] = useState({
        _id: '',

        medicalConditionName: '',
        otherMedicalConditionName: '',
        medicalConditionDescription: '',
    });

    const [showDeleteMedicalConditionConfirmationModal, setShowDeleteMedicalConditionConfirmationModal] = useState(false);

    const [error, setError] = useState({});

    const [isUpdateMedicalConditionButtonDisabled, setIsUpdateMedicalConditionButtonDisabled] = useState(false);
    const [isDeleteMedicalConditionButtonDisabled, setIsDeleteMedicalConditionButtonDisabled] = useState(false);

    const medicalConditionNameLabel = (medicalConditionName) => {
        switch (medicalConditionName) {
            case 'Allergies':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.ALLERGIES"),
                    icon: "/assets/allergies-icon-dark.svg"
                };
            case 'Asthma':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.ASTHMA"),
                    icon: "/assets/asthma-icon-dark.svg"
                };
            case 'Back Problems':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.BACK_PROBLEM"),
                    icon: "/assets/back-problems-icon-dark.svg"
                };
            case 'Nerve Damage':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.NERVE_DAMAGE"),
                    icon: "/assets/nerve-damage-icon-dark.svg"
                };
            case 'Diabetes':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.DIABETES"),
                    icon: "/assets/diabetes-icon-dark.svg"
                };
            case 'Cancer':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.CANCER"),
                    icon: "/assets/cancer-icon-dark.svg"
                };
            case 'BP':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.BP"),
                    icon: "/assets/bp-icon-dark.svg"
                };
            case 'Epilepsy':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.EPILEPSY"),
                    icon: "/assets/epilepsy-icon-dark.svg"
                };
            case 'Other':
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.OTHER"),
                    icon: "/assets/medical-condition-default-icon-dark.svg"
                };
            default:
                return {
                    label: t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.DEFAULT")
                };
        }
    }

    const handleFormData = (e) => {
        console.log(e.target.name + ': ' + e.target.value);

        setMedicalConditionDetails({
            ...medicalConditionDetails,
            [e.target.name]: e.target.value
        });

        setError({
            ...error,
            [e.target.name]: ""
        });
    }

    const handleSubmit = async () => {
        console.log("Inside Handle Submit!");

        setIsUpdateMedicalConditionButtonDisabled(true);

        console.log("Medical Condition Details: ", medicalConditionDetails);

        const medicalConditionData = {
            userAccountId: accountDetails._id,
            medicalConditionDetails: medicalConditionDetails,
        };
        const updateMedicalConditionDataResponse = await updateMedicalCondition(medicalConditionData);

        console.log('(EditMedicalConditionForm) Edit Medical Condition Data Response: ', updateMedicalConditionDataResponse);

        if (updateMedicalConditionDataResponse.success) {
            setAccountDetails(updateMedicalConditionDataResponse.data);
            setShowEditMedicalConditionForm(false);
            setIsUpdateMedicalConditionButtonDisabled(false);
            setTimeout(() => {
                setMedicalConditionDetails({
                    medicalConditionName: '',
                    otherMedicalConditionName: '',
                    medicalConditionDescription: '',
                });
            }, 200);
        }
    }

    const handleDelete = async () => {
        console.log("Inside Handle Delete!");
        setIsDeleteMedicalConditionButtonDisabled(true);

        const medicalConditionData = {
            userAccountId: accountDetails._id,
            medicalConditionId: medicalConditionDetails._id,
        };
        const deleteMedicalConditionDataResponse = await deleteMedicalCondition(medicalConditionData);

        console.log('(EditMedicalConditionForm) Delete Medical Condition Data Response: ', deleteMedicalConditionDataResponse);

        if (deleteMedicalConditionDataResponse.success) {
            setAccountDetails(deleteMedicalConditionDataResponse.data);
            setShowDeleteMedicalConditionConfirmationModal(false);
            setIsDeleteMedicalConditionButtonDisabled(false);
            setShowEditMedicalConditionForm(false);
            setIsUpdateMedicalConditionButtonDisabled(false);
            setTimeout(() => {
                setMedicalConditionDetails({
                    _id: '',

                    medicalConditionName: '',
                    otherMedicalConditionName: '',
                    medicalConditionDescription: '',
                });
                setMedicalConditionData(null);
            }, 200);
        }
    }

    const deleteMedicalConditionDetailsModalDescription = (medicalConditionName) => {
        switch (medicalConditionName) {
            case 'Allergies':
                return {
                    p1: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.ALLERGIES_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "en" ? "your" : "तुमचे"
                            : locale === "en" ? "their" : "त्यांचे"
                    }),
                    p2: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.ALLERGIES_DESCRIPTION.P2"),
                    p3: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.ALLERGIES_DESCRIPTION.P3")
                };
            case 'Asthma':
                return {
                    p1: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.ASTHMA_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "en" ? "your" : "तुमचे"
                            : locale === "en" ? "their" : "त्यांचे"
                    }),
                    p2: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.ASTHMA_DESCRIPTION.P2"),
                    p3: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.ASTHMA_DESCRIPTION.P3")
                };
            case 'Back Problems':
                return {
                    p1: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.BACK_PROBLEM_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "en" ? "your" : "तुमचे"
                            : locale === "en" ? "their" : "त्यांचे"
                    }),
                    p2: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.BACK_PROBLEM_DESCRIPTION.P2"),
                    p3: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.BACK_PROBLEM_DESCRIPTION.P3")
                };
            case 'Nerve Damage':
                return {
                    p1: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.NERVE_DAMAGE_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "en" ? "your" : "तुमचे"
                            : locale === "en" ? "their" : "त्यांचे"
                    }),
                    p2: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.NERVE_DAMAGE_DESCRIPTION.P2"),
                    p3: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.NERVE_DAMAGE_DESCRIPTION.P3")
                };
            case 'Diabetes':
                return {
                    p1: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.DIABETES_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "en" ? "your" : "तुमचे"
                            : locale === "en" ? "their" : "त्यांचे"
                    }),
                    p2: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.DIABETES_DESCRIPTION.P2"),
                    p3: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.DIABETES_DESCRIPTION.P3")
                };
            case 'Cancer':
                return {
                    p1: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.CANCER_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "en" ? "your" : "तुमचे"
                            : locale === "en" ? "their" : "त्यांचे"
                    }),
                    p2: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.CANCER_DESCRIPTION.P2"),
                    p3: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.CANCER_DESCRIPTION.P3")
                };
            case 'BP':
                return {
                    p1: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.BP_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "en" ? "your" : "तुमचे"
                            : locale === "en" ? "their" : "त्यांचे"
                    }),
                    p2: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.BP_DESCRIPTION.P2"),
                    p3: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.BP_DESCRIPTION.P3")
                };
            case 'Epilepsy':
                return {
                    p1: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.EPILEPSY_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "en" ? "your" : "तुमचे"
                            : locale === "en" ? "their" : "त्यांचे"
                    }),
                    p2: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.EPILEPSY_DESCRIPTION.P2"),
                    p3: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.EPILEPSY_DESCRIPTION.P3")
                };
            case 'Other':
                return {
                    p1: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.OTHER_DESCRIPTION.P1", {
                        pronoun: window.location.pathname.includes("personal-profile")
                            ? locale === "en" ? "your" : "तुमचे"
                            : locale === "en" ? "their" : "त्यांचे"
                    }),
                    p2: medicalConditionDetails.otherMedicalConditionName,
                    p3: t("MEDICAL_CONDITION_FORM.DELETE_MODAL.OTHER_DESCRIPTION.P3")
                };
        }
    }

    useEffect(() => {
        if (medicalConditionData) {
            console.log("Medical Condition Data in Edit Medical Condition Data Form: ", medicalConditionData);
            setMedicalConditionDetails({
                _id: medicalConditionData._id,

                medicalConditionName: medicalConditionData.medicalConditionName,
                otherMedicalConditionName: medicalConditionData.otherMedicalConditionName,
                medicalConditionDescription: medicalConditionData.medicalConditionDescription
            })
        }
    }, [medicalConditionData]);

    const handleClose = () => {
        setTimeout(() => {
            setMedicalConditionDetails({
                _id: '',

                medicalConditionName: '',
                otherMedicalConditionName: '',
                medicalConditionDescription: '',
            });
        }, 200);
        setMedicalConditionData(null);
        setShowEditMedicalConditionForm(false);
    }

    return (
        <>
            {/* Edit Medical Condition Details */}
            <Modal isOpen={showEditMedicalConditionForm}>
                <div className="fixed form-modal-container">
                    {/* Header */}
                    <div className={"form-modal-header-container"}>
                        {/* Header Title | Close Button */}
                        <div className={"flex flex-row items-center justify-between"}>
                            {/* Form Title */}
                            <h2>
                                {t("MEDICAL_CONDITION_FORM.EDIT_TITLE")}
                            </h2>

                            {/* Close Button */}
                            <button onClick={handleClose}>
                                <img
                                    className={"w-[75%] h-[75%]"}
                                    src={"/assets/close-icon.png"}
                                    alt={"Close"}
                                    title={"Close"}
                                />
                            </button>
                        </div>

                        {/* Divider */}
                        <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
                    </div>

                    {/* Form Fields */}
                    <div className={"form-modal-body-container"}>
                        {/* Medical Condition Name */}
                        <div className={`custom-input-container`}>
                            <label>
                                {t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_NAME.LABEL")}
                            </label>
                            <div className="custom-input-dropdown-button !bg-gray-100">
                                <div>
                                    <img
                                        src={medicalConditionNameLabel(medicalConditionDetails.medicalConditionName).icon}
                                        alt={medicalConditionNameLabel(medicalConditionDetails.medicalConditionName).label}
                                    />
                                    <p>
                                        {medicalConditionNameLabel(medicalConditionDetails.medicalConditionName).label}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Medical Condition Description */}
                        {
                            medicalConditionDetails.medicalConditionName === 'Other' && (
                                <div className={`custom-input-container`}>
                                    <label htmlFor="otherMedicalConditionName">
                                        {t("MEDICAL_CONDITION_FORM.OTHER_MEDICAL_CONDITION_NAME.LABEL")}
                                    </label>

                                    <div className="flex-1 flex flex-col">
                                        <input
                                            type={"text"}
                                            id="otherMedicalConditionName"
                                            className="custom-input"
                                            name='otherMedicalConditionName'
                                            value={medicalConditionDetails.otherMedicalConditionName}
                                            onChange={handleFormData}
                                        />
                                    </div>
                                </div>
                            )
                        }

                        {/* Medical Condition Description */}
                        <div className={`custom-input-container`}>
                            <label htmlFor="medicalConditionName">
                                {t("MEDICAL_CONDITION_FORM.MEDICAL_CONDITION_DESCRIPTION.LABEL")}
                            </label>

                            <div className="flex-1 flex flex-col">
                            <textarea
                                id="medicalConditionDescription"
                                className="custom-input"
                                name='medicalConditionDescription'
                                value={medicalConditionDetails.medicalConditionDescription}
                                onChange={handleFormData}
                            />
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className={"form-modal-footer-container"}>
                        {/* Divider */}
                        <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

                        {/* Delete Button | Submit Button Container */}
                        <div className="flex items-center justify-between">
                            {/* Delete Button */}
                            <button
                                disabled={isDeleteMedicalConditionButtonDisabled || isUpdateMedicalConditionButtonDisabled}
                                onClick={() => setShowDeleteMedicalConditionConfirmationModal(true)}
                                className="form-modal-footer-container-delete-button"
                            >
                                <img
                                    src="/assets/delete-icon-filled-light.png"
                                    alt="Delete"
                                />
                                <p>
                                    {t("MEDICAL_CONDITION_FORM.DELETE")}
                                </p>
                            </button>

                            {/* Submit Button */}
                            <button
                                disabled={isUpdateMedicalConditionButtonDisabled}
                                onClick={handleSubmit}
                                className="form-modal-footer-container-submit-button"
                            >
                                <p>
                                    {t("MEDICAL_CONDITION_FORM.EDIT_SUBMIT")}
                                </p>
                                <svg
                                    viewBox="0 0 6 6"
                                    fill="none"
                                    id={"arrow-icon"}
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M3 1L5 3L3 5"
                                        id={"arrow-icon-tip"}
                                        stroke="black"
                                        strokeLinecap="square"
                                    />
                                    <path
                                        d="M1 3L4 3"
                                        id={"arrow-icon-line"}
                                        stroke="black"
                                        strokeLinecap="square"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Delete Award */}
            <Modal isOpen={showDeleteMedicalConditionConfirmationModal}>
                <div className="delete-modal-container">
                    {/* Header */}
                    <div className={"delete-modal-header-container"}>
                        {/* Header Title | Close Button */}
                        <div className={"flex flex-row items-center justify-between"}>
                            {/* Form Title */}
                            <h2>
                                {t("MEDICAL_CONDITION_FORM.DELETE_MODAL.TITLE")}
                            </h2>

                            <button
                                onClick={() => setShowDeleteMedicalConditionConfirmationModal(false)}
                            >
                                <img
                                    className={"w-[75%] h-[75%]"}
                                    src={"/assets/close-icon.png"}
                                    alt={"Close"}
                                    title={"Close"}
                                />
                            </button>
                        </div>

                        {/* Divider */}
                        <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
                    </div>

                    {/* Content */}
                    {
                        medicalConditionDetails.medicalConditionName !== "" && (
                            <div className={"delete-modal-body-container"}>
                                <p>
                                    {deleteMedicalConditionDetailsModalDescription(medicalConditionDetails.medicalConditionName).p1}
                                    <span className={"!font-custom-semi-bold underline"}>
                                        {deleteMedicalConditionDetailsModalDescription(medicalConditionDetails.medicalConditionName).p2}
                                    </span>
                                    {deleteMedicalConditionDetailsModalDescription(medicalConditionDetails.medicalConditionName).p3}
                                </p>
                            </div>
                        )
                    }

                    {/* Footer */}
                    <div className={"delete-modal-footer-container"}>
                        {/* Divider */}
                        <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

                        {/* Delete | Update */}
                        <div className="flex flex-row items-center justify-between">
                            {/* Cancel Button */}
                            <button
                                disabled={isDeleteMedicalConditionButtonDisabled}
                                onClick={() => setShowDeleteMedicalConditionConfirmationModal(false)}
                                className="delete-modal-footer-container-cancel-button"
                            >
                                <p>
                                    {t("MEDICAL_CONDITION_FORM.DELETE_MODAL.CANCEL")}
                                </p>
                                <svg
                                    viewBox="0 0 6 6"
                                    fill="none"
                                    id={"arrow-icon"}
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M3 1L5 3L3 5"
                                        id={"arrow-icon-tip"}
                                        stroke="black"
                                        strokeLinecap="square"
                                    />
                                    <path
                                        d="M1 3L4 3"
                                        id={"arrow-icon-line"}
                                        stroke="black"
                                        strokeLinecap="square"
                                    />
                                </svg>
                            </button>

                            {/* Delete Button */}
                            <button
                                disabled={isDeleteMedicalConditionButtonDisabled}
                                onClick={handleDelete}
                                className="delete-modal-footer-container-delete-button"
                            >
                                <img
                                    src="/assets/delete-icon-filled-light.png"
                                    alt="Delete"
                                />
                                <p>
                                    {t("MEDICAL_CONDITION_FORM.DELETE_MODAL.DELETE")}
                                </p>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}
